<template>
  <div class="ts-space-y-3">
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('customerDeposit.phoneNumber') }}</label>
            <a-select
              class="ts-w-full"
              show-search
              v-model="model.customer_id"
              :allowClear="true"
              :placeholder="$t('customerDeposit.phoneNumber')"
              :default-active-first-option="true"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="fetching ? undefined : 'No Data'"
              @search="fetchCustomer"
              @change="onPickCustomer"
            >
              <template v-slot:notFoundContent>
                <a-spin v-if="fetching" size="small" />
              </template>
              <a-select-option
                v-for="d in customers"
                :key="d.phone_number"
                :value="d.customer_id"
              >{{ d.phone_number }}</a-select-option>
            </a-select>
            <div class="validate" v-if="errors.has('customer_id')">{{ errors.first('customer_id') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('customerDeposit.amount') }}</label>
        <input
          v-model.number="model.amount" 
          type="number" 
          step="any" 
          class="form-control"
          :class="{ 'is-invalid': errors.has('amount') }"  
        />
        <div class="invalid-feedback" v-if="errors.has('amount')">{{ errors.first('amount') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('customerDeposit.description') }}</label>
        <textarea
          v-model="model.description" 
          rows="3" 
          class="form-control"
        ></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-4 ts-flex ts-justify-end ts-space-x-3">
         <ts-button @click.prevent="$emit('close')" >{{ $t('cancel') }}</ts-button>
        <ts-button color="primary" @click.prevent="onSave">{{ $t('save') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import pwdConfirm from './confirm'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'frmCustomerDeposit',
  components: {
    pwdConfirm
  },
  data() {
    return {
      errors: new Errors(),
      fetching: false,
      customers: [],
      phone_number: null,
      model: {
        customer_id: undefined,
        amount: null,
        description: null,
        password: null
      }
    }
  },
  methods: {
    ...mapActions('accounting/customerTopup', ['store', 'getCustomer']),
    onSave() {
      // console.log(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.show_form = false)
      this.errors = new Errors()
      this.$confirm({
        title: this.$t('customerDeposit.are_you_sure_to_deposit_to'),
        content: h =>
          h(pwdConfirm, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('customerDeposit.password'),
              receiver: this.$t('customerDeposit.receiver'),
              amount: this.$t('customerDeposit.amount'),
              phone_number: this.phone_number
            }
          }),
        zIndex: 1025,
        centered: true,
        okText: this.$t('confirm'),
        onOk: () => {
         return this.store(this.model)
            .then(response => {
              this.$toasted.success(response.message)
              this.$emit('close')
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    fetchCustomer: _.debounce(function(value){
      if (!value) {
        this.customers = []
        return
      }
      this.fetching = true
      this.getCustomer(value)
        .then(response => {
          this.customers =  [response.data]
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    }, 500),
    onPickCustomer(value, option){
      this.phone_number = option.data.key
    }
  }
}
</script>